import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './LimitGroupsTableHeadRow.scss';

export const LIMIT_GROUPS_TABLE_HEADER = [
  {
    label: 'limitGroup',
    sortBy: 'limitGroupId'
  },
  {
    label: 'createDate',
    sortBy: 'createdAt'
  },
  {
    label: 'lastUpdate'
  },
  {
    label: 'customersCount'
  },
  {
    label: 'status'
  },
  {
    label: 'actions'
  }
];

export const LimitGroupsTableHeadRow = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {LIMIT_GROUPS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'limit-groups-table-head'}>
          <div className={'limit-groups-table-head-block'}>
            <span>{i18n.getMessage(`limitGroups.table.header.${head.label}`)}</span>
            {head.sortBy && (
              <ArrowSelect
                onClick={() => handleOnSortTable(head.sortBy)}
                className={`arrow-icon ${sortBy === head.sortBy && direction}`}
              />
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

LimitGroupsTableHeadRow.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};
